import { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  useEffect(() => {
    const prev = document.getElementById("ld-faq");
    if (prev) prev.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "ld-faq";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById("ld-faq")?.remove();
    };
  }, []);

  return (
    <>
      <Seo
        title="常见问题 · 师兄啊师兄剧情讨论区"
        description="师兄啊师兄剧情讨论区常见问题：作品类型、宗门篇剧情、修炼境界划分、剧透提示、追更渠道与投稿方式，追更前先看这里。"
        keywords="师兄啊师兄常见问题,师兄啊师兄宗门篇,师兄啊师兄修炼境界,师兄啊师兄投稿"
        type="website"
        path="/faq"
      />

      <section className="border-b border-background-200 bg-background-100/60 py-12 md:py-16">
        <div className="container-x">
          <nav className="flex items-center gap-1.5 text-xs text-foreground-400" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-600">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-600">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于《师兄啊师兄》这部作品与本站服务的高频疑问，都整理在下面。没找到答案？欢迎去留言讨论区提问。
          </p>
        </div>
      </section>

      <section className="container-x max-w-3xl py-12 md:py-16">
        <FaqAccordion items={faqs} />

        <div className="mt-10 flex flex-col items-center gap-3 rounded-xl border border-background-200/70 bg-background-100/60 p-6 text-center md:p-8">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-question-line text-2xl"></i>
          </span>
          <h2 className="font-heading text-lg font-semibold text-foreground-950">还有别的疑问？</h2>
          <p className="text-sm text-foreground-500">告诉我们，我们会尽快补充到常见问题里。</p>
          <Link
            to="/contact"
            className="mt-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-3-line"></i>
            去留言提问
          </Link>
        </div>
      </section>
    </>
  );
}